import React, { useState, useEffect, useCallback } from 'react';
import Switch from 'components/Switch';
import Tag from 'components/Tag';
import Icon from 'components/Icon';
import ColorPicker from 'components/ColorPicker';
import Dropdown from 'components/Dropdown';
import useBindToContext from 'hooks/useBindToContext';
import styled from 'styled-components';
import classNames from 'lib/classNames';
import _ from 'lodash'

const Input = ({
	disabled,
	disabledBgColor = "bg-gray-300",
	withSwitch,
	withDropdown,
	withNumber,
	withWeight,
	withColor,
	tags,
	onFocus,
	onBlur,
	inputRef,
	type,
	value,
	autofocus,
	icon,
	placeholder,
	className,
	style,
	onChange,
	BindToContext,
	iconFirst,
	placeholder_color,
	border_color,
	max,
	min,
	validation = true,
	getError = null,
	specificValidation = null,
	fullWidth,
	isFlex,
	step = 1,
	indicator
}) => {
	const hasTags = !!(tags && tags.length);
	const [BindedValue, BindedOnChange, hasError, onRender] = useBindToContext(
		BindToContext,
		value,
		onChange,
		specificValidation,
		getError,
		validation
	);
	const hasLeftNeighbor = !!withColor || !!withDropdown || !!hasTags;

	const [inputValue, setInputValue] = useState(BindedValue)
	//useEffect(() => {
	//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);

	const handleChange = (value) => {
		let newValue = type === 'number' && value.length ? JSON.parse(value) : value;
		if (type === 'number' && typeof newValue === 'number' && max && newValue > max) return;
		BindedOnChange(newValue);
		// setInputValue(newValue)
		// debounce(newValue);
	};

	//   const debounce = useCallback(
	// 	_.debounce((newValue) => {
	// 		BindedOnChange(newValue);
	// 	  // send the server request here		
	// 	}, 200),
	// 	[]
	//   );

	return (
		<>
			<div
				className={classNames(className, 'flex rounded focus-within-ring border', {
					'w-full': !isFlex,
					[disabledBgColor]: disabled,
					'bg-white': !disabled,
					'border-red-400': hasError,
				})}
				data-tags={hasTags}
			>
				{!!withColor && (
					<ColorPicker data_input={true} value={withColor.value} color_type="rgb" onChange={withColor.onChange} />
				)}

				{!!withDropdown && <Dropdown {...withDropdown} className={classNames('w-17')} inInput={true} first />}
				{icon && iconFirst && (
					<div className={classNames('flex ml-2 text-xs rounded-l items-center')}>
						{icon.icon && <Icon {...icon} />}
						{icon.char && <span>{icon.char}</span>}
					</div>
				)}
				{!!hasTags && (
					<div className={classNames('flex ml-2 items-center')}>
						{tags.map(({ id, title, onClose, style = {} }, i) => (
							<Tag key={i} style={style} title={title} id={id} onClose={(id) => onClose(id)} />
						))}
					</div>
				)}

				<input
					onChange={({ target: { value } }) => handleChange(value)}
					step={step}
					onFocus={(e) => {
						if (onFocus) onFocus(e);
					}}
					disabled={disabled}
					onBlur={(e) => {
						if (onBlur) onBlur(e);
					}}
					placeholder_color={placeholder_color}
					ref={inputRef}
					type={type}
					value={BindedValue}
					max={max}
					min={min}
					placeholder={!hasTags ? placeholder : null}
					className={classNames(
						'border-0 shadow-none min-w-0 w-full appearance-none flex-1 flex-grow py-2 px-3 text-sm text-gray-700 focus:outline-none bg-inherit',
						{
							'rounded-r': hasLeftNeighbor,
							rounded: !hasLeftNeighbor,
							'placeholder-red-400': hasError,
						}
					)}
					autoFocus={autofocus}
				/>

				{icon && !iconFirst && (
					<div
						className={classNames(
							'h-full flex p-2 items-center justify-center bg-gray-300 text-blue-500 font-bold text-sm rounded-r'
						)}
					>
						{icon.icon && <Icon {...icon} />}
						{icon.char && <span>{icon.char}</span>}
					</div>
				)}
				{withSwitch && (
					<div className={classNames('flex items-center justify-center bg-white mr-3 rounded-r border-l pl-2')}>
						<Switch onFocus={onFocus} onBlur={onBlur} BindToContext={withSwitch} />
					</div>
				)}
				{withWeight && (
					<div className={classNames('flex items-center')}>
						<span className={classNames('bg-gray-300 number-input-separator')}></span>
						<input
							type="number"
							value={withWeight.value}
							onChange={withWeight.onChange}
							min={withWeight.min || 0}
							max={withWeight.max || 900}
							onFocus={(e) => {
								if (onFocus) onFocus(e);
							}}
							step={withWeight.step || step}
							onBlur={(e) => {
								if (onBlur) onBlur(e);
							}}
							className={classNames(
								'w-12 focus:outline-none appearance-none text-sm py-2 pl-3 text-gray-700 items-center'
							)}
						/>
						<div className={classNames('pr-2 flex flex-col relative ')}>
							<button type='button' onClick={() => withWeight.onClick(withWeight.value + withWeight.step)} className={classNames('focus:ring-0 focus:outline-none p-0 flex-1 flex-center')}><Icon icon="caret-up" /></button>
							<button type='button' onClick={() => withWeight.onClick(withWeight.value - withWeight.step)} className={classNames('focus:ring-0 focus:outline-none p-0 flex-1 flex-center')}><Icon icon="caret-down" /></button>
						</div>
					</div>
				)}
				{withNumber && (
					<div className={classNames('flex items-center')}>
						<span className={classNames('bg-gray-300 number-input-separator')}></span>
						<input
							type="number"
							value={withNumber.value}
							onChange={withNumber.onChange}
							min={withNumber.min || 0}
							onFocus={(e) => {
								if (onFocus) onFocus(e);
							}}
							step={withNumber.step || step}
							onBlur={(e) => {
								if (onBlur) onBlur(e);
							}}
							className={classNames(
								'w-12 focus:outline-none appearance-none text-sm py-2 pl-3 text-gray-700 items-center'
							)}
						/>
						<div className={classNames('pr-2 flex flex-col relative ')}>
							<button type='button' onClick={() => withNumber.onClick(withNumber.value + withNumber.step)} className={classNames('focus:ring-0 focus:outline-none p-0 flex-1 flex-center')}><Icon icon="caret-up" /></button>
							<button type='button' onClick={() => withNumber.onClick(withNumber.value - withNumber.step)} className={classNames('focus:ring-0 focus:outline-none p-0 flex-1 flex-center')}><Icon icon="caret-down" /></button>
						</div>
						{withNumber.icon.icon ||
							(withNumber.icon.char && (
								<div
									className={classNames(
										'h-full flex p-2 items-center justify-center bg-gray-300 text-blue-500 font-bold text-sm rounded-r'
									)}
								>
									{withNumber.icon.icon && <Icon {...withNumber.icon} />}
									{withNumber.icon.char && <span>{withNumber.icon.char}</span>}
								</div>
							))}
					</div>
				)}
			</div>
			{
				indicator && <p className={classNames("text-gray-500 text-xs italic")}>{indicator}</p>
			}
		</>
	);
};

Input.defaultProps = {
	switch: false,
	tags: [],
	disabled: false,
	style: {},
	onEnter: false,
	onFocus: false,
	onBlur: false,
	onKeyDown: false,
	inputRef: null,
	BindToContext: null,
	dispatch: null,
	placeholder: '',
	withSwitch: false,
	withNumber: false,
	withDropdown: false,
	value: undefined,
	className: '',
	iconFirst: false,
	placeholder_color: null,
	border_color: null,
	max: null,
	min: null,
};

export default Input;
